export default {
  CPF_OR_CNPJ:
    /^([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})$/gi,

  PHONE_NUMBER: /^(\(?\d{2}\)?)\s?(9)?\s?(\d{4})-?(\d{4})$/gi,

  STRONG_PASSWORD: /^(?=.*[A-Za-z])(?=.*d)(?=.*[@$!%*#?&])[A-Za-zd@$!%*#?&]{8,}$/gi,

  INCLUDE_NUMBER_CHAR: /[0-9]/gi,

  INCLUDE_UPPER_CHAR: /[A-Z]/gi,

  INCLUDE_SPECIAL_CHAR: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/gi
};
